import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllFieldAssessmentsUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllFieldAssessments
  implements GetAllFieldAssessmentsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAllFieldAssessmentsUseCaseInterface.Params,
  ): Promise<GetAllFieldAssessmentsUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}${params.id}/field-assessments`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
